import { render } from "./NewAcceptTermLogin.vue?vue&type=template&id=39e4a0a6"
import script from "./NewAcceptTermLogin.vue?vue&type=script&lang=js"
export * from "./NewAcceptTermLogin.vue?vue&type=script&lang=js"

import "./NewAcceptTermLogin.vue?vue&type=style&index=0&id=39e4a0a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__